import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface VideoCardProps {
  id: string;
  title: string;
  thumbnail: string;
  author: string;
  authorAvatar: string;
  views: number;
  likes: number;
  duration: string;
  category?: string;
}

function formatNumber(num: number): string {
  if (num >= 10000) {
    return (num / 10000).toFixed(1) + "万";
  }
  return num.toString();
}

export default function VideoCard({ id, title, thumbnail, author, authorAvatar, views, likes, duration }: VideoCardProps) {
  const { t } = useTranslation();

  return (
    <Link
      to={`/article/${id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-white text-xs">
          {duration}
        </span>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 opacity-0 group-hover:opacity-100 transition-opacity">
            <i className="ri-play-fill text-xl text-primary-500 ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <div className="mt-2 flex items-center gap-2">
          <img src={authorAvatar} alt={author} className="w-6 h-6 rounded-full object-cover" loading="lazy" />
          <span className="text-xs text-foreground-500">{author}</span>
        </div>
        <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatNumber(views)}{t("common.playCount")}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-heart-line"></i>
            {formatNumber(likes)}
          </span>
        </div>
      </div>
    </Link>
  );
}